module.exports = __webpack_public_path__ + "img/lucas-shigihara-byn.35ae95b5.jpg";